module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"add":"Добавить карту"}}')
  delete Component.options._Ctor
}
